import React from 'react'
import { Link } from 'react-router-dom'
import './ui.css'

/**
 * Хлебные крошки. Элементы: { label, to? } — у последнего без `to` отображается как текущая страница.
 */
function Breadcrumb ({ items, className = '', ariaLabel = 'Навигация' }) {
  if (!items?.length) return null
  return (
    <nav className={`ds-breadcrumb ${className}`.trim()} aria-label={ariaLabel}>
      {items.map((item, i) => {
        const isLast = i === items.length - 1
        const key = `${i}-${item.to ?? ''}-${item.label}`
        return (
          <React.Fragment key={key}>
            {i > 0 && <span className="ds-breadcrumb-sep" aria-hidden>›</span>}
            {isLast || !item.to ? (
              <span className="ds-breadcrumb-current">{item.label}</span>
            ) : (
              <Link to={item.to}>{item.label}</Link>
            )}
          </React.Fragment>
        )
      })}
    </nav>
  )
}

export default Breadcrumb
